import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";

const ItemMasterModal = ({ showModal, closeModal, branch, onSelectItem }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const pageSize = 10;

  useEffect(() => {
    if (showModal) {
      fetchItems(currentPage, searchTerm);
    }
  }, [showModal, currentPage, searchTerm]);

  const fetchItems = async (page, search) => {
    setLoading(true);
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/itemMaster_modal", {
        params: {
          search: search,
          page: page,
          limit: pageSize,
        },
      });
      setItems(response.data.data);
      const total = response.data?.total ?? 0;
setTotalPages(Math.ceil(total / pageSize));

    } catch (error) {
      console.error("Error fetching items:", error);
    }
    setLoading(false);
  };

  const handleSelectItem = (item) => {
    onSelectItem(item);
    closeModal();
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  if (!showModal) return null;

  return (
  <div className="modal-item">
    <div className="modal-content-item">
      {/* Close button on top-right */}
      <button className="modal-close-item" onClick={closeModal}>×</button>

      <h3 className="modal-title-item">Select Your ItemCode</h3>

      <div className="search-filter">
        <p>Search Itemcode & Name:</p>
        <input
          type="text"
          className="search-input"
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setCurrentPage(1); // Reset on search
          }}
          placeholder="Type to search..."
        />
      </div>

      <div className="search-results-item">
        <table>
          <thead>
            <tr>
              <th>Item Code</th>
              <th>Item Name</th>
              <th>Select</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="3" className="loading-text">Loading...</td></tr>
            ) : items.length > 0 ? (
              items.map((item) => (
                <tr key={item.code}>
                  <td>{item.code}</td>
                  <td>{item.itemName}</td>
                  <td><button className="select-btn" onClick={() => handleSelectItem(item)}>Select</button></td>
                </tr>
              ))
            ) : (
              <tr><td colSpan="3">No results found</td></tr>
            )}
          </tbody>
        </table>

        {/* Pagination Controls */}
        <div className="pagination-bar-item">
          <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>‹ Prev</button>
          <span>Page {currentPage} of {totalPages}</span>
          <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next ›</button>
        </div>
      </div>
    </div>
  </div>
);

};

export default ItemMasterModal;
